export const RECORDINGS_SCROLL_KEY_PREFIX = 'scroll_patient_recordings_';
